<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="part _idGenParaOverride-1" id="_idParaDest-3">Book One<br/><em>How The Swordsman Was Summoned</em></h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ReluctantSwordsman2.vue?8cb7df58